import { render, staticRenderFns } from "./ApiKeyValue.vue?vue&type=template&id=97653250&scoped=true"
import script from "./ApiKeyValue.vue?vue&type=script&lang=js"
export * from "./ApiKeyValue.vue?vue&type=script&lang=js"
import style0 from "./ApiKeyValue.vue?vue&type=style&index=0&id=97653250&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97653250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97653250')) {
      api.createRecord('97653250', component.options)
    } else {
      api.reload('97653250', component.options)
    }
    module.hot.accept("./ApiKeyValue.vue?vue&type=template&id=97653250&scoped=true", function () {
      api.rerender('97653250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/ApiKeyValue.vue"
export default component.exports